/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".skeleton-loader[_ngcontent-%COMP%]{animation:1.2s ease-in-out infinite skeleton-animation;background-color:#eee;background-image:linear-gradient(90deg,#eee,#f5f5f5,#eee);background-repeat:no-repeat;background-size:200px 100%;height:50px;margin-bottom:5px}"];
export { styles as styles };
